var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizard-container" }, [
    _vm.savingSurveyInProgress
      ? _c(
          "div",
          { staticClass: "progress-bar-container" },
          [
            _c("label", {
              domProps: { innerHTML: _vm._s(_vm.savingProgressContent) }
            }),
            _c("br"),
            _c("progress-bar", {
              attrs: {
                options: _vm.ProgressBarOptions,
                value: _vm.progressBarValue
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.$store.state.userData.role == "super-admin" ||
    _vm.$store.state.settings.enable_survey_feature == 1
      ? _c(
          "form",
          { attrs: { "data-vv-scope": "add-survey" } },
          [
            _vm.$store.state.userData.role == "super-admin" ||
            _vm.$store.state.userData.surveyFeature == 1
              ? _c(
                  "form-wizard",
                  {
                    attrs: {
                      title: "Create Survey",
                      subtitle: "",
                      shape: "tab",
                      "back-button-text": "Back!",
                      "next-button-text": "Next!",
                      "finish-button-text": "Submit",
                      color: "#82DE6D"
                    },
                    on: {
                      "on-complete": _vm.surveySaved,
                      "on-error": _vm.handleErrorMessage
                    }
                  },
                  [
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Basic Details",
                          icon: "ti-align-justify",
                          "before-change": _vm.checkBasicDetailsValidation
                        }
                      },
                      [
                        _c("BasicSurveyDetails", {
                          attrs: {
                            basicSurveyDetails: _vm.basicSurveyDetails,
                            surveyId: _vm.surveyId
                          },
                          on: {
                            basicDetailsUpdated: _vm.updateSurveyBasicDetails
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Add Questions",
                          icon: "ti-settings",
                          "before-change": _vm.checkQuestionAnswersValidateion
                        }
                      },
                      [
                        _vm.QuestionDataExistsInLocalStorage
                          ? _c(
                              "span",
                              {
                                staticClass: "localstorage-existing-data-notice"
                              },
                              [
                                _vm._v(
                                  "You have unsaved changes in your brwoser, click "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click:
                                        _vm.fillLocalStorageQuestioncDetails
                                    }
                                  },
                                  [_vm._v("here")]
                                ),
                                _vm._v(" to prefill those!")
                              ]
                            )
                          : _vm._e(),
                        _vm._l(_vm.surveyQuestionAnswers, function(
                          question,
                          qi
                        ) {
                          return _c("QuestionBuilder", {
                            key: "root-" + qi,
                            attrs: {
                              question: question,
                              questionIndex: qi,
                              questionPath: [qi],
                              parentPath: [],
                              level: 0,
                              basicSurveyDetails: _vm.basicSurveyDetails,
                              errors: _vm.errors,
                              validator: _vm.$validator
                            },
                            on: {
                              "remove-question": _vm.removeQuestion,
                              "add-answer": _vm.addAnswerToQuestion,
                              "remove-answer": _vm.removeAnswer,
                              "add-followup": _vm.addFollowUpQuestion,
                              "remove-followup": _vm.removeFollowUpQuestion
                            }
                          })
                        }),
                        _vm.basicSurveyDetails.type == "MEDIA" &&
                        _vm.surveyQuestionAnswers.length <
                          this.$store.state.settings
                            .max_questions_per_media_survey
                          ? _c(
                              "a",
                              {
                                staticClass: "add-question-button",
                                attrs: { href: "javascript:;" },
                                on: { click: _vm.AddQuestion }
                              },
                              [_vm._v("+  Question")]
                            )
                          : _vm._e(),
                        _vm.basicSurveyDetails.type == "PICKL" &&
                        _vm.surveyQuestionAnswers.length <
                          this.$store.state.settings.max_questions_per_survey
                          ? _c(
                              "a",
                              {
                                staticClass: "add-question-button",
                                attrs: { href: "javascript:;" },
                                on: { click: _vm.AddQuestion }
                              },
                              [_vm._v("+  Question")]
                            )
                          : _vm._e(),
                        _vm.basicSurveyDetails.type == "NON_GEO" &&
                        _vm.surveyQuestionAnswers.length <
                          this.$store.state.settings
                            .max_questions_per_non_geo_survey
                          ? _c(
                              "a",
                              {
                                staticClass: "add-question-button",
                                attrs: { href: "javascript:;" },
                                on: { click: _vm.AddQuestion }
                              },
                              [_vm._v("+  Question")]
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Review",
                          icon: "ti-eye",
                          "before-change": _vm.submitForm
                        }
                      },
                      [
                        _c("ReviewSurvey", {
                          attrs: {
                            basicSurveyDetails: _vm.basicSurveyDetails,
                            surveyQuestionAnswers: _vm.surveyQuestionAnswers
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c("div", [
                  _c(
                    "h2",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _vm._v("This feature is only available for "),
                      _c("strong", [_vm._v("Essentials")]),
                      _vm._v(" & "),
                      _c("strong", [_vm._v("Pro")]),
                      _vm._v(" plans"),
                      _c("br"),
                      _vm._v("click "),
                      _c(
                        "router-link",
                        { attrs: { to: "/brand/subscription" } },
                        [
                          _c("strong", { staticClass: "upgrade-link" }, [
                            _vm._v("Here")
                          ])
                        ]
                      ),
                      _vm._v(" to upgrade your plan")
                    ],
                    1
                  )
                ])
          ],
          1
        )
      : _c("h2", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Survey Feature is not available for you!")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }